
<template>
  <div>

    <!-- 검색 데이터 모달로 만들 부분  -->
    <div
      class="admin_addModalBox"
      :class="statusData.modalStatus ? '' : 'display_none'"
    >
      <div class="admin_addModalBox_dim">
      </div>
      <div class="admin_addModalBox_inner">
        <div class="admin_addModalBox_tit">
          <p>여행상품등록</p>
          <button
            class="admin_addModalBox_BtnClose"
            v-on:click="modal_close"
          >
          </button>
        </div>

        <div class="admin_addModalBox_search">
          <input
            type='text'
            id = 'search_data'
            name = 'search_data'
            maxLength="30"
            placeholder = "여행상품명을 입력해주세요."
            v-model="statusData.searchInputData"
          />
          <button
            v-on:click="travel_product_search"
          >
            검색
          </button>
        </div>

        <div class="admin_addModalBox_result">
          <!-- 검색한 데이터가 없을 시  -->
          <div
            class="admin_addModalBox_result_noData"
            v-if="this.statusData.searchData.length === 0">
            <p>{{this.statusData.searchDataText}}</p>
          </div>

          <!-- 검색한 데이터가 있을시 시  -->
          <div
            class="admin_addModalBox_result_Data"
            v-else
            >

            <ul class="admin_addModalBox_result_Data_ulTit">
              <li>여행타입</li>
              <li>여행상품명</li>
              <li>등록하기</li>
            </ul>

            <ul class="admin_addModalBox_result_Data_ulInfo"
              v-for="item in statusData.searchData"
              :key="item.travel_product_ID"
              >
              <li class="admin_addModalBox_result_Data_li_text">{{item.travel_type_name}}</li>
              <li class="admin_addModalBox_result_Data_li_text">{{item.travel_product_name}}</li>
              <li class="admin_addModalBox_result_Data_li_btn">
                <button
                  v-on:click="add_product(
                    item.travel_product_ID,
                    item.travel_type_name,
                    item.travel_product_name
                  )"
                >
                  등록
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> <!-- 검색 데이터 모달로 만들 부분  -->

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'3-3'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>메인화면 관리 - 이달의 추천여행 배너 관리</p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn02" v-on:click="add_colum">추가</button>
            <button class="Admin_PageHeader_btn03" v-on:click="delete_row">삭제</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>1. 리스트 정렬은 ID와 상관없이 순서대로이며, 상단이 우선 순위가 높습니다.</p>
            <p>2. 왼쪽 3선 작대기를 클릭&드래그하여 위/아래로 이동할 수 있습니다.</p>
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_recommend_month_banner,
  get_recommend_month_banner_search,
  insert_recommend_month_banner_one,
  update_recommend_month_banner,
  update_recommend_month_banner_status,
  update_recommend_month_banner_order,
  delete_recommend_month_banner
} from '../../ETC/Axios.vue'
import {
  getTodayDate
} from '../../ETC/Validation.vue'
import { ref } from 'vue'

export default {
  name: 'AdminNfuPickManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null,
      statusData: ref({
        modalStatus: false,
        searchData: [],
        searchInputData: '',
        searchDataText: '여행상품을 검색해주세요.',
        clickRecommendMonthBannerID: 0
      })
    }
  },
  methods: {
    add_colum: function () {
      insert_recommend_month_banner_one().then((result) => {
        this.tabulator.addRow({
          id: result[0].recommend_month_banner_ID,
          travel_product_ID_use_recommend_month_banner: 0,
          recommend_month_banner_ID: result[0].recommend_month_banner_ID,
          travel_type_name: '',
          travel_product_name: '',
          recommend_month_banner_status: '미사용',
          recommend_month_banner_registe: getTodayDate()
        }, true)
      })
    },
    delete_row: function () {
      let temp_delete_array = []
      this.tabulator.getSelectedData().forEach((element) => {
        temp_delete_array.push(element.recommend_month_banner_ID)
      })
      delete_recommend_month_banner(temp_delete_array).then((result) => {
        if (result === undefined) {
          alert('삭제가 되지 않았습니다. 관리자한테 확인해주세요.')
        } else {
          alert('삭제가 완료 되었습니다.')
          window.location.reload()
        }
      })
    },
    detail_icon: function () {
      return `
      <span class="pointTextBlue">여행상품 변경하기</span>
      `
    },
    cell_click: function (e, cell) {
      this.statusData.modalStatus = true
      this.statusData.clickRecommendMonthBannerID = cell.getRow().getData().recommend_month_banner_ID
    },
    cell_edited: function (cell) {
      if (cell._cell.column.field === 'recommend_month_banner_status') {
        const recommend_month_banner_status_array = ['', '사용', '미사용']
        const recommend_month_banner_ID = cell.getData().recommend_month_banner_ID
        const recommend_month_banner_status = cell._cell.value
        const travel_product_ID_use_recommend_month_banner = cell.getData().travel_product_ID_use_recommend_month_banner
        if (travel_product_ID_use_recommend_month_banner === 0) {
          alert('여행상품 지정 후 사용 여부를 변경할 수 있습니다.')
          this.tabulator.updateData([{
            id: recommend_month_banner_ID,
            recommend_month_banner_status: cell._cell.oldValue
          }])
        } else if (recommend_month_banner_status !== '') {
          update_recommend_month_banner_status(
            recommend_month_banner_ID,
            recommend_month_banner_status
          ).then(result => {
            this.tabulator.updateData([{
              id: recommend_month_banner_ID,
              recommend_month_banner_status: recommend_month_banner_status_array[recommend_month_banner_status]
            }])
          })
        } else {
          this.tabulator.updateData([{
            id: recommend_month_banner_ID,
            recommend_month_banner_status: cell._cell.oldValue
          }])
        }
      }
    },
    modal_close: function () {
      this.statusData.modalStatus = false
    },
    travel_product_search: function () {
      if (this.statusData.searchInputData.length < 3) {
        alert('최소 3자이상 입력해주세요.')
      } else {
        get_recommend_month_banner_search(this.statusData.searchInputData).then(result => {
          if (result.length === 0) {
            this.statusData.searchData = []
            this.statusData.searchDataText = '검색에 맞는 여행상품이 없습니다.'
          } else {
            this.statusData.searchData = result
          }
        })
      }
    },
    add_product: function (
      travel_product_ID,
      travel_type_name,
      travel_product_name
    ) {
      update_recommend_month_banner(
        this.statusData.clickRecommendMonthBannerID,
        travel_product_ID
      ).then(result => {
        this.tabulator.updateData([{
          id: this.statusData.clickRecommendMonthBannerID,
          travel_product_ID_use_recommend_month_banner: travel_product_ID,
          recommend_month_banner_ID: this.statusData.clickRecommendMonthBannerID,
          travel_type_name: travel_type_name,
          travel_product_name: travel_product_name
        }])
        this.statusData.modalStatus = false
      })
    }
  },
  mounted () {
    get_recommend_month_banner().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        movableRows: true,
        columns: [
          {rowHandle: true, formatter: 'handle', headerSort: false, frozen: true, width: 30, minWidth: 30},
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: 'id', field: 'id', headerSort: false, visible: false},
          {title: '여행상품ID', field: 'travel_product_ID_use_recommend_month_banner', headerSort: false, visible: false},
          {title: 'ID', field: 'recommend_month_banner_ID', headerSort: false},
          {title: '여행상품등록(클릭)',
            formatter: this.detail_icon,
            hozAlign: 'center',
            headerSort: false,
            cellClick: this.cell_click
          },
          {title: '여행타입명', field: 'travel_type_name', headerSort: false},
          {title: '여행상품명', field: 'travel_product_name', headerSort: false},
          {
            title: '사용 여부(클릭)',
            field: 'recommend_month_banner_status',
            headerSort: false,
            editor: 'list',
            cellEdited: this.cell_edited,
            editorParams: {
              values: {
                '1': '사용',
                '2': '미사용'
              }
            }
          },
          {title: '등록 일자', field: 'recommend_month_banner_registe', headerSort: false},
          {title: '수정 일자', field: 'recommend_month_banner_modified', headerSort: false}
        ]
      })
      this.tabulator.on('rowMoved', function (row) {
        let temp_recommend_month_banner_order_array = []
        let recommend_month_banner_order = 0
        const table = row.getTable()
        table.getRows().forEach(element => {
          temp_recommend_month_banner_order_array.push({
            recommend_month_banner_order: recommend_month_banner_order,
            recommend_month_banner_ID: element._row.data.recommend_month_banner_ID
          })
          recommend_month_banner_order++
        })
        update_recommend_month_banner_order(temp_recommend_month_banner_order_array).then(result => {
          if (result === undefined) {
            alert('순서가 변경되지 않았습니다. 관리자한테 확인해주세요.')
          }
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MainManagement/AdminRecommendMonthBannerManagement.vue